export default "__VITE_ASSET__8bdcf6d6__"